// const extractOrganizationCode = (url) => {
//   return /^(.*)\.zendesk\.com/g.exec(url)[1]
// }

export class ZendeskController {
  constructor () {
    this.system = 'zendesk'
    this.onAddNote = () => {}
  }

  fetchCredentials (agent) {
    return new Promise((resolve, reject) => {
      // this.client.db.get('unbabelToken').then(resolve, (err) => {
      //   if (err.status === 404) {
      //     resolve({ organizationId: null, token: null })
      //   } else {
      //     reject(err)
      //   }
      // })
    })
  }

  uploadAuthorization (organizationId, token) {
    return new Promise((resolve, reject) => {
      // this.client.db.set('unbabelToken', { organizationId, token })
      //   .then(resolve, reject)
    })
  }

  /**
   * Should always return a list of objects in the form:
   * [{ code: '123', name: 'John Doe', email: 'john@doe.com', language: 'en' }, ...]
   */
  async fetchAgents () {
    // const code = 'unbabeltest'
    // const url = `https://${code}.freshdesk.com/api/v2/agents`
    // const encode = (username, password = 'X') =>
    //   window.btoa(unescape(encodeURIComponent(`${username}:${password}`)))

    // const options = {
    //   headers: {'Authorization': `Basic ${encode('Ym3EjGVr72O3YLQt2Em')}`}
    // }
    // return new Promise((resolve, reject) => {
    //   this.client.request.get(url, options)
    //     .then((r) => {
    //       const { response } = r
    //       const agents = JSON.parse(response)
    //         .map(({ id, contact: { name, email, language } }) => {
    //           return { code: id, name, email, language }
    //         })
    //       resolve(agents)
    //     }, (err) => {
    //       reject(err)
    //     })
    // })
    return Promise.resolve([])
  }

  fetchClientAgent () {
    return new Promise((resolve, reject) => {
      this.client.get(['currentUser.id', 'currentUser.locale'])
        .then((result) => {
          resolve({
            agentCode: `${result['currentUser.id']}`,
            preferredLanguage: `${result['currentUser.locale']}`
          })
        }, reject)
    })
  }

  getTicketDetails (agentCode = null) {
  }

  getThreadForMessagePayload (agentCode = null) {
  }

  resizeApplet ({ height }) {
  }

  closeApplet () {
  }

  reloadParent () {}

  prependNote (text) {
  }

  fetchOrganizationCode () {
  }

  static initialize () {
    return new Promise((resolve, reject) => {
      const app = window.ZEN_APP

      if (!app) {
        throw Error('No zendesk app object present')
      }

      const client = app.init()
      client.on('app.registered', () => {
        localStorage.setItem('counter', (localStorage.getItem('counter') || 0) + 1)
        console.log(localStorage.getItem('counter'))
        const controller = new ZendeskController()
        // we need to set .client as a non enumerable, just so that vue doesn't have to access the parent Window object
        // if that happens we'll get a browser error. With enumerable as false, .client will not be watched and will
        // not be copied; it gets hidden when doing Object.keys()
        Object.defineProperty(controller, 'client', {
          value: client,
          enumerable: false
        })
        return resolve(controller)
      })
    })
  }

  generateFetch () {
    return (url, options) => {
      return new Promise((resolve, reject) => {
        console.log(`Will go to ${url}`, options)
        const payload = {
          url,
          headers: {'Authorization': 'JWT {{jwt.token}}'},
          jwt: {
            algorithm: 'HS256',
            secret_key: 'some_shared_secret',
            expiry: 3600,
            claims: {
              iat: 1372113305,
              jti: '8883362531196.326',
              iss: 'some_subdomain'
            }
          },
          type: 'GET',
          dataType: 'json'
        }
        // const payload = {
        //   url,
        //   type: options.method || 'GET',
        //   headers: {
        //     ...options.headers,
        //     'Authorization': 'JWT {{jwt.token}}'
        //   },
        //   jwt: {
        //     algorithm: 'HS256',
        //     expiry: 3600,
        //     secret_key: 'shared_secret',
        //     claims: {
        //       iat: Date.now(),
        //       // jti: '8883362531196.326',
        //       iss: 'unbabel1462805092.zendesk.com' // TODO: client._origin
        //     }
        //   },
        //   secure: true,
        //   dataType: 'json',
        //   autoRetry: true,
        //   data: options.body
        // }
        this.client.request(payload)
          .then((result) => {
            resolve()
          }, reject)
      })
    }
  }

  static getSystemName () {
    return 'zendesk'
  }
}



// WEBPACK FOOTER //
// ./src/api/zendesk.js